import { useEffect, useState } from "react";
import { MonitorFaturamentoService } from "../../../../services";
import { responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

function MonitorFatRankingServicos({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    buscarRankingServicos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarRankingServicos() {
    setLoading(true);
    const result = await monitorFaturamentoService.rankingServicos(filtrosBody);
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const itens = rows.map((r) => ({
    key: r.servicoId,
    label: r.descricao,
    valor: r.valor,
  }));

  return (
    <MonitorFatCard
      titulo="Top 5 Serviços Mais Faturados"
      icone="ph-hammer"
      loading={loading}
      alturaSkeleton={160}
    >
      <MonitorFatRankingBarra itens={itens} />
    </MonitorFatCard>
  );
}

export default MonitorFatRankingServicos;
